import { cn } from '@/lib/utils';

interface SegOption<T extends string | number> {
  value: T;
  label: string;
  icon?: React.ReactNode | undefined;
}

interface SegmentedControlProps<T extends string | number> {
  value: T;
  onChange: (v: T) => void;
  options: ReadonlyArray<SegOption<T>>;
  className?: string | undefined;
  size?: 'sm' | 'md' | undefined;
  /** Quando true, cada botão usa largura natural do texto em vez de dividir igual. */
  fitContent?: boolean;
}

export function SegmentedControl<T extends string | number>({
  value,
  onChange,
  options,
  className,
  size = 'md',
  fitContent = false,
}: SegmentedControlProps<T>) {
  return (
    <div
      className={cn(
        'inline-flex rounded-lg bg-muted p-1 gap-1',
        fitContent ? '' : 'w-full',
        className,
      )}
      role="tablist"
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={String(opt.value)}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(opt.value)}
            className={cn(
              'rounded-md font-medium transition-all flex items-center justify-center gap-2 whitespace-nowrap',
              fitContent ? 'flex-none' : 'flex-1',
              size === 'sm' ? 'text-xs px-3 py-1.5' : 'text-sm px-3 py-2',
              active
                ? 'bg-primary text-primary-foreground shadow-red'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {opt.icon}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
